import Vue from 'vue'
import Router from 'vue-router'

import index from '../views/axj_web'
import wxCert from '@/components/axj_wx_cert'
import certification from "../views/axj_web/axj_certification/index"
import axjMain from '../views/axj-main'
import axjShowClub from '../views/axj-extracurricular/axj-show-club'
import axjWithinSchool from '../views/axj-information/axj-within-school'
import axjPost from '../views/axj-information/axj-post'
import axjCompetitionClub from '../views/axj-extracurricular/axj-competition-club'
import axjWork from '../views/axj-service/axj-work'
import axjCourse from '../views/axj-help/axj-course'
import axjViewClub from '../views/axj-information/axj-view-club'
import axjStation from '../views/axj-information/axj-station'
import error from '../views/axj-error/error'

Vue.use(Router)
const router= new Router({
	routes: [
	{
	    path:'/',
        name:'index',
        component:index
    },
    {
      path:'/cert',
      name:'cert',
      component: wxCert
    },
   {
	    path:'/certification',
      name: 'certification',
      component: certification
    },
    {
	    path: '/axjMain',
      name:'axjMain',
      component: axjMain,
      children:[
        {
          path:'/axjWork',
          name:'axjWork',
          component:axjWork
        },
        {
          path:'/axjShowClub',
          name:'axjShowClub',
          component:axjShowClub
        },
        {
          path:'/error',
          name:'error',
          component:error
        },
        {
          path:'/',
          name:'axjWithinSchool',
          component:axjWithinSchool
        },
        {
          path:'/axjPost',
          name:'axjPost',
          component: axjPost
        },
        {
          path: '/axjCompetitionClub',
          name: 'axjCompetitionClub',
          component: axjCompetitionClub
        },
        {
          path: '/axjWork',
          name: 'axjWork',
          component: axjWork
        },
        {
          path: '/axjCourse',
          name: 'axjCourse',
          component: axjCourse
        },
        {
          path: '/axjViewClub',
          name:'axjViewClub',
          component: axjViewClub
        },{
	        path: '/axjStation',
          name: 'axjStation',
          component: axjStation
        }
      ]
    },

	]
})

router.beforeEach(async (to,form,next)=>{
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js